import supabase from '../supabase/supabase';

const ENDPOINT = '/.netlify/functions/ai-review';

export const CATEGORY_LABELS = {
  ordem: 'Ordem',
  coerencia: 'Coerência',
  padronizacao: 'Padronização',
  concisao: 'Concisão',
  terminologia: 'Terminologia',
  gramatica: 'Gramática',
};

async function call(method, body) {
  const { data: { session } } = await supabase.auth.getSession();
  if (!session) throw new Error('Entre novamente para usar a revisão.');
  const response = await fetch(ENDPOINT, {
    method,
    headers: { Authorization: `Bearer ${session.access_token}`, ...(body ? { 'Content-Type': 'application/json' } : {}) },
    ...(body ? { body: JSON.stringify(body) } : {}),
  });
  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(payload?.error || 'Não foi possível concluir a revisão.');
    err.quota = payload?.quota || null;
    err.status = response.status;
    throw err;
  }
  return payload;
}

export const fetchAiReviewQuota = () => call('GET').then((r) => r.quota);
export const requestAiReview = (reportId, text) => call('POST', { report_id: reportId, text });
// Feedback nunca carrega texto do laudo; falha em silêncio.
export const sendAiReviewFeedback = (body) => call('POST', { action: 'feedback', ...body }).catch(() => null);

const escapeRegExp = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

// Acha `original` no texto do editor ignorando diferenças de espaço/quebra de linha.
export function locateInText(text, original) {
  const parts = String(original || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return null;
  const match = new RegExp(parts.map(escapeRegExp).join('\\s+')).exec(String(text || ''));
  return match ? { index: match.index, length: match[0].length } : null;
}

// Aplica a troca no Quill preservando o formato do trecho. Devolve false se o trecho não existe mais.
export function applyReplacement(quill, original, sugerido) {
  const found = locateInText(quill.getText(), original);
  if (!found) return false;
  const format = quill.getFormat(found.index, Math.min(found.length, 1) || 1);
  quill.deleteText(found.index, found.length, 'user');
  quill.insertText(found.index, sugerido, format, 'user');
  return true;
}

export const renewalLabel = (iso) => {
  const d = iso ? new Date(iso) : null;
  return d && Number.isFinite(d.getTime()) ? d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' }) : null;
};
